import { Asserts, number, object, string } from 'yup';

export const contactUsSchema = object({
  enquiryTypeId: number().integer().positive().required(),
  description: string().trim().min(2).max(300).required(),
});

export type ContactUsSchemaDataType = Asserts<typeof contactUsSchema>;
